// Marketing bundle — loaded only by `app/views/layouts/marketing.html.erb`.
// Marketing pages stay Rails-rendered ERB for SEO + SSR; this file ships
// only the JS those pages actually use, instead of the full `application.js`
// (which still feeds Devise/admin/paywall layouts during the migration).
//
// Controllers shipped here, in order of how often they're hit:
//   - menu             — mobile nav drawer in `shared/_marketing_header`
//   - cookie-consent   — bottom-right banner; calls `initPostHog()` on accept
//   - load-more        — blog infinite scroll (uses Turbo Streams)
//   - syntax-highlight — code blocks in `docs/`
//   - code-tabs        — multi-language tab switcher in `docs/`
//
// Turbo is kept because `blog_posts#index` responds with `format.turbo_stream`
// for the load-more pagination. PostHog is pulled in transitively by
// cookie_consent_controller's import.

import "@hotwired/turbo-rails"

import { Application } from "@hotwired/stimulus"

import MenuController from "./controllers/menu_controller"
import CookieConsentController from "./controllers/cookie_consent_controller"
import LoadMoreController from "./controllers/load_more_controller"
import SyntaxHighlightController from "./controllers/syntax_highlight_controller"
import CodeTabsController from "./controllers/code_tabs_controller"
import ModalController from "./controllers/modal_controller"
import ToastController from "./controllers/toast_controller"

const application = Application.start()
application.register("menu", MenuController)
application.register("cookie-consent", CookieConsentController)
application.register("load-more", LoadMoreController)
application.register("syntax-highlight", SyntaxHighlightController)
application.register("code-tabs", CodeTabsController)
application.register("modal", ModalController)
application.register("toast", ToastController)
